module.exports = __webpack_public_path__ + "static/media/linkedin.4901d4b5.svg";